module.exports = __webpack_public_path__ + "static/media/Developmenticon05@3x.3cabb491.png";